
export default class LoadLogosGrid {
	constructor(el) {

		this.companyList 		= el.querySelector('.b-logos-grid__companies')
		this.companies			= [...el.querySelectorAll('.company')]
		this.loadMoreButton 	= el.querySelector('[data-load-more]')
		this.loadMore 			= this.loadMore.bind(this)
		this.updateNumbers 		= this.updateNumbers.bind(this)
		this.dataToIncrease 	= this.companyList.dataset.num
		this.loadMoreCurrent 	= el.querySelector('[data-current]')
		this.loadMoreTotal 		= el.querySelector('[data-total]')

		if(window.app.isDesktop){
			this.dataToIncrease = Number(this.companyList.dataset.num);
		} else if(window.app.isTablet){
			this.dataToIncrease = Number(this.companyList.dataset.tabNum);
		} else if(window.app.isMobile){
			this.dataToIncrease = Number(this.companyList.dataset.mobNum);
		}
		this.currentlyVisible 	= this.dataToIncrease

		// console.log( 'currentlyVisible: ', this.currentlyVisible)
		// console.log('data to increase: ', this.dataToIncrease)
		// console.log(this.loadMoreCurrent)
		// console.log(this.loadMoreTotal)


		// const handleResize = (e, size) => {
		// 	if (e.matches) {
		// 		console.log('viewport is ' + size + '!');  
		// 	} else {
		// 		// console.log('viewport below ' + size + '!');  
		// 	}
		// }

		// handleResize(this.isDesktop)


		// https://www.nray.dev/blog/using-media-queries-in-javascript/
		// const mediaQuery = matchMedia("(min-width: 1024px)");

		// mediaQuery.addEventListener("change", (e) => {
		// 	// Using `e.matches` is not prone to expensive style recalcs/layout
		// 	// that checking properties like `window.innerWidth` might cause.
		// 	if (e.matches) {
		// 		this.dataNum = this.companyList.dataset.num
		// 		// The viewport is >= 1000px wide.
		// 	}
		// });






		if(this.dataToIncrease){
			if(this.companies.length > this.dataToIncrease) {
				this.companies.slice(this.dataToIncrease).forEach((company)=> {
					company.style.display = 'none';
				})
				this.updateNumbers()
			}
		}
	
		this.loadMoreButton && this.loadMoreButton.addEventListener('click', () => {
			this.loadMore();
		})


	}

	updateNumbers()	{
		this.loadMoreCurrent.innerHTML = this.currentlyVisible
		this.loadMoreTotal.innerHTML = this.companies.length
	}

	checkSizing() {
		if(window.app.isDesktop){
			this.dataToIncrease = Number(this.companyList.dataset.num);
		} else if(window.app.isTablet){
			this.dataToIncrease = Number(this.companyList.dataset.tabNum);
		} else if(window.app.isMobile){
			this.dataToIncrease = Number(this.companyList.dataset.mobNum);
		}
		// console.log('data to increase: ', this.dataToIncrease)
	}
  
	loadMore() {

		this.checkSizing()

		this.currentlyVisible = parseInt(this.currentlyVisible) + this.dataToIncrease;
		
		// console.log( 'currentlyVisible: ', this.currentlyVisible)

		let companySelection = this.companies.slice(0, this.currentlyVisible);

		companySelection.forEach((company)=> {
			company.style.display = 'block';
		})

		if(this.currentlyVisible >= this.companies.length) {
			this.loadMoreButton.parentNode.style.display = 'none';
		}

		this.updateNumbers()

	}
  
}